module.exports = __webpack_public_path__ + "static/media/aws.c98196eb.png";